export const pageLayoutMaxWidthPixels = 1920;
export const pageLayoutMaxWidth = pageLayoutMaxWidthPixels + 'px';
//# sourceMappingURL=layout.js.map